/**
 * 系统管理-消息
 * @author xingzb
 * @date 2020-02-10
 */
import request from "@/utils/request";

/**
 * 应用通知管理/短信发送管理
 */
export function getNoteOrSMSManageList(query) {
  return request({
    url: `/ntocc-basic-api/notice`,
    method: "get",
    params: query
  });
}
export function addNoteOrSMSManage(query) {
  return request({
    url: `/ntocc-basic-api/notice`,
    method: "post",
    params: query
  });
}
export function getNoteOrSMSManage(code) {
  return request({
    url: `/ntocc-basic-api/notice/${code}`,
    method: "get"
  });
}
export function updateNoteOrSMSManage(query) {
  return request({
    url: `/ntocc-basic-api/notice`,
    method: "put",
    params: query
  });
}
export function delNoteOrSMSManage(query) {
  return request({
    url: `/ntocc-basic-api/notice`,
    method: "delete",
    params: query
  });
}
// 推送托运人/司机
export function pushNoticeOrSendSMS(query) {
  return request({
    url: `/ntocc-basic-api/notice/pushNoticeOrSendSms`,
    method: "put",
    params: query
  });
}

/**
 * 消息推送记录
 */
export function getNoticeRecordList(query) {
  return request({
    url: `/ntocc-basic-api/noticeRecord`,
    method: "get",
    params: query
  });
}

/**
 * 短信验证码
 */
export function getPINManageList(query) {
  return request({
    url: `/ntocc-basic-api/smsRecord`,
    method: "get",
    params: query
  });
}

/**
 * 司机催款记录
 */
export function getPaymentRecordsList(query) {
  return request({
    url: `/ntocc-basic-api/urgeRemit`,
    method: "get",
    params: query
  });
}
// 变更单项已读状态
export function updateReadStatus(query) {
  return request({
    url: `/ntocc-basic-api/urgeRemit`,
    method: "put",
    params: query
  });
}
// 变更选中已读状态
export function updateCheckedReadStatus(query) {
  return request({
    url: `/ntocc-basic-api/urgeRemit/setReadBatch`,
    method: "put",
    params: query
  });
}
